import { Toaster } from 'react-hot-toast';
import { useMediaQuery } from '@/hooks/useMediaQuery';

export function AppToaster() {
  const isMobile = useMediaQuery('(max-width: 640px)');
  return (
    <Toaster
      position={isMobile ? 'bottom-center' : 'top-right'}
      toastOptions={{
        className:
          '!font-sans !rounded-md !bg-card !text-card-foreground !border !border-border !shadow-ticket',
        success: {
          iconTheme: { primary: 'hsl(152 70% 36%)', secondary: 'hsl(0 0% 100%)' },
        },
        error: {
          iconTheme: { primary: 'hsl(0 84% 42%)', secondary: 'hsl(0 0% 100%)' },
        },
      }}
    />
  );
}
